import React from 'react'

import { observer } from 'mobx-react'

import NavBar from '~/client/src/desktop/components/NavBar/NavBar'
import * as Layout from '~/client/src/shared/components/Layout'
import Tabs from '~/client/src/shared/components/Tabs/Tabs'

import ProjectSetUp from '../ProjectSetUp/ProjectSetUp'
import Reports from '../Reports/Reports'
import AnalyticsStore, { Tab } from './Analytics.store'
import HubV2 from './components/HubV2/HubV2'

import './Analytics.scss'

@observer
export default class Analytics extends React.Component {
  private store: AnalyticsStore = new AnalyticsStore()

  public render() {
    return (
      <Layout.View className="overflow-hidden analytics-view">
        <Layout.Header className="layout-navigation">
          <NavBar />
        </Layout.Header>
        <div className="row full-height meucontainer">
          <ProjectSetUp sidebarOnly className="col full-height w-fit-content" />
          <div className="col full-height analytics-content-wrapper">
            <div className="row h-fit-content no-grow analytics-tabs-container">
              <Tabs
                tabObjects={this.store.tabs}
                activeTabId={this.store.activeTab}
                onTabClick={this.store.changeActiveTab}
                className="bb-light-grey mt15"
                tabClassName="row x-center y-center pointer analytics-view-tab"
                tabTextClassName="text center extra-large ellipsis px5"
              />
            </div>
            <div className="row analytics-content-area">{this.content}</div>
          </div>
        </div>
      </Layout.View>
    )
  }

  private get content() {
    // Render the appropriate component based on the active tab
    switch (this.store.activeTab) {
      case Tab.Dashboard:
        return <HubV2 />
      case Tab.Reports:
        return <Reports />
    }
  }
}
